export default __webpack_public_path__ + "static/media/gold.70d5bf49.png";